import React, { useEffect, useState } from "react";
import { Box} from "@mui/material";
import { SubpageTitle } from "../../../components/atoms/text/titles";
import { useQueryBackend } from "../../../utils/requestHelpers";
import { Nullable } from "../../../common-types";
import { BarChartView, IDataItem } from "../../../components/atoms/charts";
import { getDistinctPropertyValues } from "../../../functions";
import { DateTime } from "luxon";
import { DateRangePickerPopUp } from "../../../components/molecules/datepickers/dateRangePickerPopUp";
import { TagButton } from "../../../components/molecules/datepickers/tagButtons";
import { IColorMap } from "../../../components/atoms/charts/barChartView";
import { compareVersions } from "./softwareVersionUtils";
import { LabledCheckbox } from "../../../components/molecules/LabledCheckbox";



interface CyclesItem {
  date: string;
  softwareVersion: Nullable<string>;
  amount: number;
}

export const MachineSoftwareVersionHistory = ({
  seeAllMachines,
  name
}: {
  seeAllMachines?: boolean
  name?: string | undefined;
}) => {

  const today = DateTime.now()
  const stepper = {month: 1}
  const todayRollingSeven = today.minus(stepper);
  const lastMonthStart = today.minus(stepper).startOf("month");
  const lastMOnthEnd = today.minus(stepper).endOf("month");
  const queryApi = useQueryBackend("Backoffice");
  const [from, setFrom] = useState<DateTime>(todayRollingSeven);
  const [to, setTo] = useState<DateTime>(today);
  const [data, setData] = useState<Array<IDataItem>>([]);
  const [colorMap, setColorMap] = useState<IColorMap[]>([])  


  function generateColorMap(versions: string[]): IColorMap {
    const colorMap: IColorMap = {};
    const totalVersions = versions.length;

    // Generate colors based on position in the sorted array
    versions.forEach((version, index) => {
        const position = index / (totalVersions - 1); // Normalized position (0 for lowest, 1 for highest)
        // Calculate RGB values for red to yellow to green gradient
        const r = position === 1 ? 109 : Math.round(220 - (position) * 190);
        const g = position === 1 ? 156 : Math.round(220 - (position ) * 190);;
        const b = position === 1 ? 119 : Math.round(220 - (position ) * 190);

        colorMap[version] = `rgb(${r}, ${g}, ${b})`;
    });

    return colorMap;
}




useEffect(() => {

    if(!from || !to) return
      queryApi
        .Get<Array<CyclesItem>>(
          `software-versions/history-between-${from.toFormat(
            "yyyy-MM-dd"
          )}-to-${to.toFormat("yyyy-MM-dd")}
          ${seeAllMachines ? "" : "?param=onlyActivated" }`
        )
        .Data((d) => {
          const allDays = getDistinctPropertyValues(d, "date");
          const allVersions = getDistinctPropertyValues(d, "softwareVersion").sort(compareVersions);
          setColorMap(generateColorMap(allVersions))
          const items = allDays.map((day) => {
            const item: IDataItem = { name: day };
            allVersions
              .filter((s) => !!s)
              .forEach((k) => {
                item[k!] =
                  d.find((d) => d.date === day && d.softwareVersion === k)?.amount ?? 0;
              });
            return item;
          });


          setData(items);
        });
  }, [ from, to, seeAllMachines]);
  const [open, setOpen] = useState<boolean>(false);
  const presets:TagButton [] = [
    {
      name:  "Rolling month" ,
      id: "rolling",
      action: () => {
        setFrom(todayRollingSeven);
        setTo(today);
        setOpen(false);
      },
    },
    {
      name:  "Last Month",
      id: "last",
      action: () => {
        setFrom(lastMonthStart);
        setTo(lastMOnthEnd);
        setOpen(false);
      },
    },
  ];
  return (
    <Box>
      <SubpageTitle title={name ?? "Software version history"} />
      {/* <LabledCheckbox isChecked={seeAllMachines} setIsChecked={setSeeAllMachines} lable={"All machines"} /> */}

      <Box>
        <DateRangePickerPopUp
          startDate={from}
          endDate={to}
          onStartDatePicked={setFrom}
          onEndDatePicked={setTo}
          presets={presets}
          open={open}
          setOpen={setOpen}
        ></DateRangePickerPopUp>
      </Box>
      <div style={{ width: "100%", height: "400px" }}>
        <BarChartView
          useCostomLEgend
          items={data}
          colorMap={colorMap}
          formatX={(s) => s.substring(s.lastIndexOf("-") + 1)}
        />
      </div>
    </Box>
  );
};
